<template>
  <div class="form-row">
    <InputText class="col-sm-6"
      v-bind:field="_formFields[0]"
      v-bind:value="nameData.first_name"
      v-on:input="updateField('first_name', $event)"/>
    <InputText class="col-sm-6"
      v-bind:field="_formFields[1]"
      v-bind:value="nameData.last_name"
      v-on:input="updateField('last_name', $event)"/>
  </div>
</template>

<script>
import CmsMixin from '@/mixins/CmsMixin';
import InputMixin from '@/mixins/InputMixin';
import FormMixin from '@/mixins/FormMixin';
import InputText from '@/components/inputs/simple/InputText.vue';

/**
 * Input Full Name
 * -- Implements v-model
 *
 * A field that renders two text inputs and returns an object with
 * a first and last name.
 */
export default {
  name: 'InputFullName',
  components: {
    InputText,
  },
  mixins: [
    InputMixin,
    FormMixin,
    CmsMixin,
  ],
  props: {
    /**
     * The value object
     */
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      /**
       * The local store for the value prop (prevents race conditions).
       */
      nameData: Object.assign({}, this.value),
      /**
       * The configuration for the text inputs.
       */
      formFields: [
        {
          title: 'First Name',
          key: 'first_name',
          min_length: 2,
          required: true,
          disabled: this.isDisabled('first_name'),
        },
        {
          title: 'Last Name',
          key: 'last_name',
          min_length: 2,
          required: true,
          disabled: this.isDisabled('last_name'),
        },
      ],
    };
  },
  computed: {
    /**
     * Modifies the form fields to get input titles from CMS.
     */
    _formFields() {
      return this.formFields.map((field) => {
        const titledField = Object.assign({}, field);
        titledField.title = this.getCMSText(field.key, {}, field.title);
        return titledField;
      });
    },
  },
  methods: {
    /**
     * Updates the local store for value and emit the new value.
     * @param key {String} the key to update
     * @param value {String} the new value of the key
     */
    updateField(key, value) {
      this.nameData[key] = value;
      this.errors.remove('full_name');
      this.$emit('input', this.nameData);
    },
    /**
     * @param key {String} key used to check the name field value.
     * @return {Boolean}
     */
    isDisabled(key) {
      return Boolean(this.value[key] && this.field?.disabled);
    },
  },
  watch: {
    /**
     * Update the local store for value with the new object.
     * @param newVal {Object} the new object to assign
     */
    value(newVal) {
      this.nameData = Object.assign({}, newVal);
    },
  },
};
</script>
